import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/apiClient";
import { formatApiError } from "../lib/errors";
import { toast } from "sonner";
import { Lock, ArrowRight, ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. You are signed in.");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err, "Could not reset password"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 rounded-md bg-[#0B1B3D] grid place-items-center"><span className="font-display font-black text-white">K</span></div>
          <p className="font-display font-extrabold text-[#0B1B3D] text-xl">Reset your password</p>
        </div>
        {!token && (
          <div className="rounded-lg bg-[#EF4444]/10 border border-[#EF4444]/30 p-4 text-sm text-[#0B1B3D]">This reset link is invalid or incomplete. Please request a new one from the sign-in screen.</div>
        )}
        {token && (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <div>
              <label className="text-xs font-bold text-[#0B1B3D] font-display">New password (min 8 chars)</label>
              <div className="relative mt-1">
                <Lock className="w-4 h-4 text-[#94A3B8] absolute left-3 top-1/2 -translate-y-1/2" />
                <input data-testid="reset-password-input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-slate-200 rounded-lg pl-10 pr-3 py-2.5 text-sm focus:border-[#0EA5E9] focus:outline-none focus:ring-2 focus:ring-[#0EA5E9]/20" placeholder="••••••••" />
              </div>
            </div>
            <div className="flex items-start gap-2 text-xs text-[#475569]"><ShieldCheck className="w-4 h-4 text-[#10B981] mt-0.5 shrink-0" /><p>Resetting your password signs you out of all devices.</p></div>
            <button data-testid="reset-submit" type="submit" disabled={busy} className="w-full bg-[#0B1B3D] disabled:opacity-50 text-white hover:bg-[#1E3A8A] px-5 py-3 rounded-lg font-bold text-sm font-display inline-flex items-center justify-center gap-2">{busy ? "Resetting…" : "Reset password"} <ArrowRight className="w-4 h-4" /></button>
          </form>
        )}
      </div>
    </div>
  );
}
